<ul class="navbar-nav shadow text-white sidebar" [ngClass]="{ 'sidebar-hidden': !sidebarVisible }">

    <a class="sidebar-brand">
        <div class="sidebar-brand-icon">
            <img  src="assets/images/logo_white.png" style="max-width: 100px; max-height: 50px;">
            <div class="sidebar-brand-text">GENERAL SECURITY</div>
        </div>
    </a>

    <hr class="sidebar-divider my-0">

    <li class="nav-item shadow-lg" *ngIf="level==1">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/mi-recinto" routerLinkActive="item-active"
            [routerLinkActiveOptions]="{exact: true}">
            <i class="fas fa-fw fa-tachometer-alt"></i>
            <span>Home</span></a>
    </li>
    <li class="nav-item shadow-lg" *ngIf="level==2">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/supervisor" routerLinkActive="item-active"
            [routerLinkActiveOptions]="{exact: true}">
            <i class="fas fa-fw fa-tachometer-alt"></i>
            <span>Home</span></a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/central-de-seguridad"
            routerLinkActive="item-active">
            <i class="fa-solid fa-display"></i>
            <span>CENTRAL</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level==99">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/supervision"
            routerLinkActive="item-active">
            <i class="fa-solid fa-clipboard-user"></i>
            <span>SUPERVISIÓN</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/configuracion"
            routerLinkActive="item-active">
            <i class="fa-solid fa-pen-ruler"></i>
            <span>AJUSTES</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/control-ingreso/instalaciones/gestion"
            routerLinkActive="item-active">
            <i class="fa-solid fa-map-location-dot"></i>
            <span>INSTALACIONES</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/control-ingreso/dependencias/gestion"
            routerLinkActive="item-active">
            <i class="fa-solid fa-warehouse"></i>
            <span>DEPENDENCIAS</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/control-ingreso/registro/gestion" routerLinkActive="item-active">
            <i class="fa-regular fa-clipboard"></i>
            <span>CONTROLES</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/control-ingreso/registro/guardias" routerLinkActive="item-active">
            <i class="fa-solid fa-person-military-pointing"></i>
            <span>GUARDIAS</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/control-ingreso/registro/dispositivos" routerLinkActive="item-active">
            <i class="fa-solid fa-mobile"></i>
            <span>DISPOSITIVOS</span>
        </a>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item shadow-lg" *ngIf="level>9">
        <a class="nav-link d-flex flex-column align-items-center" routerLink="/logs" routerLinkActive="item-active">
            <i class="fas fa-clipboard-list"></i>

            <span>LOGS</span>
        </a>
    </li>
    <app-clock-digital />
</ul>
